import { Stack, Typography } from "@mui/material";
import React from "react";

const EmptyComponent = () => {
  return (
    <>
      <Stack
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        className="my-24 "
      >
        <img
          src={"/icons/empty-icon4x.png"}
          width={"120px"}
          height={"120px"}
          alt=""
        />
        <Typography className="!my-8">
          Güncel İşlemleriniz Bulunmamaktadır.
        </Typography>
      </Stack>
    </>
  );
};

export default EmptyComponent;
